"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureAreComponentsEqual = exports.areComponentsEqual = void 0;

// react hot loader causes component
// equality checks to fail. However it provides a work around function
// areComponentsEqual
var areComponentsEqual = function areComponentsEqual(a, b) {
  return a === b;
};

exports.areComponentsEqual = areComponentsEqual;

var configureAreComponentsEqual = function configureAreComponentsEqual(fn) {
  return exports.areComponentsEqual = areComponentsEqual = fn;
};

exports.configureAreComponentsEqual = configureAreComponentsEqual;